var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 19.7188L15.5625 15.5312C16.4688 14.4375 16.9688 13.0312 16.9688 11.5C16.9688 7.9375 14.0312 5 10.4688 5C6.875 5 4 7.9375 4 11.5C4 15.0938 6.90625 18 10.4688 18C11.9688 18 13.375 17.5 14.5 16.5938L18.6875 20.7812C18.8438 20.9375 19.0312 21 19.25 21C19.4375 21 19.625 20.9375 19.75 20.7812C20.0625 20.5 20.0625 20.0312 19.75 19.7188ZM5.5 11.5C5.5 8.75 7.71875 6.5 10.5 6.5C13.25 6.5 15.5 8.75 15.5 11.5C15.5 14.2812 13.25 16.5 10.5 16.5C7.71875 16.5 5.5 14.2812 5.5 11.5Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.d2c3cca08ea389ef79fc5e24841d1197.svg";
export { ForwardRef as ReactComponent };